import { render, staticRenderFns } from "./ModalMessageDetailsModal.vue?vue&type=template&id=59eddfc0&scoped=true"
import script from "./ModalMessageDetailsModal.vue?vue&type=script&lang=js"
export * from "./ModalMessageDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59eddfc0",
  null
  
)

export default component.exports